export default {
  "home": {
    "listen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listen to Great Music!"])}
  },
  "register": {
    "TOS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terms of Service"])},
    "accept": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["I accept ListenUp's ", _interpolate(_list(0))])}
  },
  "song": {
    "comment_count": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["No comments"]), _normalize(["1 Comment"]), _normalize([_interpolate(_named("count")), " Comments"])])}
  }
}